import { render, staticRenderFns } from "./DashboardHorizontal.vue?vue&type=template&id=48b263b5&scoped=true&"
import script from "./DashboardHorizontal.vue?vue&type=script&lang=js&"
export * from "./DashboardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHorizontal.vue?vue&type=style&index=0&id=48b263b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b263b5",
  null
  
)

export default component.exports